// src/components/ui/label.tsx
import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cn } from "../../lib/utils"

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root data-component-id="src/components/ui/label.tsx:10:2" data-component-path="src/components/ui/label.tsx" data-component-line="10" data-component-file="label.tsx" data-component-name="LabelPrimitive.Root" data-component-content="%7B%22elementName%22%3A%22LabelPrimitive.Root%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
    ref={ref}
    className={cn("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70", className)}
    {...props}
  />
))

Label.displayName = LabelPrimitive.Root.displayName

export { Label }
